import { FormControl, InputLabel, TextField, Typography } from '@mui/material'
import React from 'react'

const CustomInputField = ({ type, value, onChange, fullWidth, disabled, label, ...props }) => {
    return (
        <div>
            <Typography sx={{
                fontFamily: 'Times New Roman',
                fontWeight: '400',
                fontSize: '18px',
                lineHeight: '20.7px',
                color: '#3D3D3D',
                paddingBottom: '10px'
            }}>{label}</Typography>
            <FormControl fullWidth variant="outlined">
                <TextField
                    id="custom-text-field"
                    type={type}
                    value={value}
                    fullWidth={fullWidth}
                    onChange={onChange}
                    variant="outlined"
                    disabled={disabled}
                    sx={{
                        border: '1px',
                        borderRadius: '5px',
                        borderColor: '#D0D0D0',
                        background: disabled ? '#e6e6e6' : '',
                        '& .MuiOutlinedInput-root': {
                            fontFamily: 'Times New Roman',
                            fontSize: '17px',
                            height: '45px', // Set the desired height
                            '& fieldset': {
                                borderColor: '#D0D0D0',
                            },
                            '&:hover fieldset': {
                                borderColor: '#D0D0D0',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#D0D0D0',
                            },

                        },
                        "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: "#272727",
                        },
                    }}
                    {...props} // Pass any additional props
                />
            </FormControl>
        </div>

    )
}

export default CustomInputField